import { defineStore } from 'pinia';
import services from '../services/faq';
import { pushToDataLayer } from '@/js/analytics/analytics.methods.js';
import { useHead } from '@unhead/vue';

export const useFaqStore = defineStore('faqStore', {
  state: () => {
    return {
      accordionList: [],
      categories: [],
      categoriesExpanded: false,
      controller: null,
      currentSearchTerm: null,
      faqAccordionHeadingRef: null,
      langAttribute: 'en-gb',
      pageId: null,
      resultPage: false,
      selectedCategoryId: null,
      selectedCategoryTitle: null,
      searchTerm: null,
      showAccordionList: false,
      searchPredictions: [],
      pageTitle: null,
    };
  },
  getters: {
    accordionListLength: (state) => state.accordionList.length,
  },
  actions: {
    fetchSearchSuggestions(term) {
      this.useRequestController();
      let payload = {
        id: this.pageId,
        term: term,
      };
      return services
        .faqSearchPredictions(payload, this.langAttribute)
        .then((response) => {
          this.controller = null;
          if (response.data.searchPredictions?.length) {
            this.searchPredictions = response.data.searchPredictions;
          } else {
            this.searchPredictions = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchSearchResults(payload, isSearch) {
      this.useRequestController();
      return services
        .searchResults({ ...payload, id: this.pageId }, this.langAttribute)
        .then((response) => {
          this.controller = null;
          this.accordionList = response.data.searchResults;
          this.showAccordionList = true;
          if (isSearch) {
            this.resultPage = true;
            this.currentSearchTerm = this.searchTerm;
            this.selectedCategoryId = null;
            this.selectedCategoryTitle = null;
            this.searchTerm = '';
            this.searchPredictions = [];
          } else {
            this.resultPage = false;
          }
          this.checkParamsId();
        })
        .then(() => {
          this.faqAccordionHeadingRef.focus();
          this.faqAccordionHeadingRef.scrollIntoView(true, { behavior: 'smooth' });
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          pushToDataLayer({
            event: 'faq_load_list',
            number_returned_results: this.accordionList.length,
          });

          if (this.resultPage && this.accordionList.length === 0) {
            pushToDataLayer({
              event: 'faq_no_search_result',
              faq_search_term: this.currentSearchTerm,
            });
          }
        });
    },
    useRequestController() {
      if (this.controller) {
        this.controller.abort();
      }
      this.controller = new AbortController();
    },
    checkAllCategoriesOnPageLoad() {
      const params = this.checkParams();
      const termParam = params.get('allCat');

      if (termParam === 'true') {
        this.categoriesExpanded = true;
      } else {
        this.categoriesExpanded = false;
      }
    },
    checkParamsOnPageLoad() {
      const params = this.checkParams();
      const termParam = params.get('term');

      if (termParam) {
        this.checkParamsTerm(params);
      } else {
        this.checkParamsCat(params);
      }
    },
    checkParamsTerm(params) {
      const termParam = params.get('term');
      this.fetchSearchResults({ term: termParam }, true);
      this.searchTerm = termParam;
    },
    checkParamsCat(params) {
      const catParam = params.get('cat');
      if (catParam) {
        const matchingCategory = this.categories.find((cat) => cat.id === catParam);
        if (matchingCategory) {
          !matchingCategory.featured && (this.categoriesExpanded = true);
          this.selectedCategoryId = matchingCategory.id;
          this.selectedCategoryTitle = matchingCategory.title;
          useHead({
            title: `${this.pageTitle} | ${matchingCategory.title}`,
            link: {
              rel: 'canonical',
              href: window.location.href,
            },
          });
          this.fetchSearchResults({ cat: matchingCategory.id });
        }
      }
    },
    checkParamsId() {
      const params = this.checkParams();
      const idParam = params.get('id');
      if (idParam) {
        const matchingFaqIndex = this.accordionList.findIndex((el) => el.id === idParam);
        if (matchingFaqIndex + 1) {
          this.accordionList[matchingFaqIndex].focusAndScroll = true;
        }
      }
    },
    checkParams() {
      return new URL(document.location).searchParams;
    },
    resetLanding() {
      this.resultPage = false;
      this.searchTerm = null;
      this.currentSearchTerm = null;
      this.showAccordionList = false;
      this.accordionList = [];
      window.history.replaceState(null, null, window.location.pathname);
    },
  },
});
